module.exports = __webpack_public_path__ + "static/media/coming-soon.a3058757.png";